import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowButton } from '@ff-os/shared-react/components/window/partials/WindowButton';
import { WindowFooter } from '@ff-os/shared-react/components/window/partials/WindowFooter';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { useCloseWindow } from '@ff-os/shared-react/context/window/useWindowContext';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectFontFamilyNameById } from '../../_redux';
import { FontFamilyOptionList } from './FontFamilyOptionList';

const _FontFamilyWindow = ({ variableIds, selectedFontFamily }: Props) => {

    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const onClose = useCloseWindow(() => setIsOpen(false));

    return (
        <>
            <WindowButton chevron icon={<Icon type='font-family' />} onClick={() => setIsOpen(true)}>
                <span style={{ fontFamily: selectedFontFamily, fontWeight: 'normal' }}>
                    {selectedFontFamily}
                </span>
            </WindowButton>

            <WindowContext isOpen={isOpen} close={() => setIsOpen(false)}>
                <WindowContext.Header>
                    <WindowHeader previous={onClose}>
                        {t('windows.font_family.heading')}
                    </WindowHeader>
                </WindowContext.Header>
                <WindowContext.Body>
                    <FontFamilyOptionList gap='xs' variableIds={variableIds} />
                </WindowContext.Body>
                <WindowContext.Footer>
                    <WindowFooter justify='end'>
                        <Button onClick={onClose}>
                            {t('commons.save')}
                        </Button>
                    </WindowFooter>
                </WindowContext.Footer>
            </WindowContext>
        </>
    );
};

type Props = {
    variableIds: string[];
    selectedFontFamily: string;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    fonts: state.fonts,
    selectedFontFamily: selectFontFamilyNameById(state, ownProps.variableIds[0]!)!
});

export const FontFamilyWindow = connect(
    mapStateToProps
)(_FontFamilyWindow);